import { createReducer } from '@reduxjs/toolkit';

import getArticles from '../../thunks/articles/getArticles';
import { setArticles } from '../../thunks/articles/patchArticles';

const initialState = {
  loading: false,
  error: '',
  data: null,
  currentPage: 1,
  lastPage: undefined
};

const getArticlesReducer = createReducer(initialState, {
  [getArticles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getArticles.fulfilled]: (state, { payload: { data, current_page: currentPage, last_page: lastPage } }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage
  }),
  [setArticles]: (state, { payload }) => ({
    ...state,
    // eslint-disable-next-line no-underscore-dangle
    data: state?.data?.map((item) => (item?._id === payload._id ? payload : item))
  }),
  [getArticles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
});

export default getArticlesReducer;
